<script>


export default {
  name: 'Navigation',

  props: {
    image: {
      required: true,
      type: String,
      default: '',
    },
    title: {
      required: false,
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isExpanded: false,
      viewingMode: 'light-mode',
    };
  },

  mounted() {
    this.viewingMode = localStorage.getItem('darkMode') ? 'dark-mode' : 'light-mode';
  },

  methods: {
    close(event) {
      this.showModal = false;
      this.$emit('close');
    },
    open(event) {
      this.showModal = true;
      this.$emit('open');
    },
    cancel(event) {
      this.showModal = false;
    }
  }
};

</script>

<template>
  <div id="navigation" class="flex items-center justify-between flex-wrap" :class="viewingMode">
    <div class="py-2 px-4 mr-6 bg-primary">
      <a href="/" class="flex flex-row items-stretch font-semibold text-xl tracking-tight leading-none"><img
          :src="image" alt="logo" class="h-10 w-10">
        <span v-if="title" class="ml-4 self-center">{{ title }}</span>
      </a>
    </div>

    <div class="block lg:hidden" @click="isExpanded = (isExpanded + 1) % 2">
      <button
          class="flex items-center p-3 border rounded text-blue-lighter border-blue-light hover:text-blue-light hover:border-white">
        <i class="fas fa-bars"></i>
      </button>
    </div>

    <div v-if="isExpanded" class="d-block lg:hidden w-full flex-grow lg:flex lg:items-center lg:w-auto">
      <div class="lg:flex-grow"></div>
      <div class="pt-2">
        <slot></slot>
      </div>
    </div>

    <div class="hidden lg:d-block w-full block flex-grow lg:pr-4 lg:flex lg:items-center lg:w-auto">
      <div class="lg:flex-grow"></div>
      <div class="pt-2">
        <slot></slot>
      </div>
    </div>
  </div>

</template>
